import { createContext, useContext } from 'react';
import type { AppConfig } from '@dvms/shared-types';

const ConfigContext = createContext<AppConfig | null>(null);

export function ConfigProvider({ config, children }: { config: AppConfig; children: React.ReactNode }) {
    return <ConfigContext value={config}>{children}</ConfigContext>;
}

export function useConfig(): AppConfig {
    const config = useContext(ConfigContext);
    if (!config) {
        throw new Error('useConfig must be used within a ConfigProvider');
    }
    return config;
}
